import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const toast     = useToast();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('يرجى إدخال اسم المستخدم وكلمة المرور');
      return;
    }
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate('/');
    } catch (err) {
      toast.error(err.message === 'Invalid username or password'
        ? 'اسم المستخدم أو كلمة المرور غير صحيحة'
        : 'حدث خطأ، يرجى المحاولة مرة أخرى');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* Background Pattern */}
      <div style={styles.bg} />

      <div style={styles.container}>
        {/* Logo */}
        <div style={styles.logoWrap}>
          <div style={styles.logoIcon}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div>
            <h1 style={styles.logoTitle}>نظام العمولات</h1>
            <p style={styles.logoSub}>شركة ريادة طرية للدواجن</p>
          </div>
        </div>

        {/* Form Card */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>تسجيل الدخول</h2>
          <p style={styles.cardSub}>أدخل بياناتك للوصول إلى حسابك</p>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="input-label">اسم المستخدم</label>
              <input
                className="input"
                type="text"
                placeholder="أدخل اسم المستخدم"
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoComplete="username"
                autoCapitalize="none"
                disabled={loading}
              />
            </div>

            <div className="input-group">
              <label className="input-label">كلمة المرور</label>
              <input
                className="input"
                type="password"
                placeholder="أدخل كلمة المرور"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-full btn-lg"
              disabled={loading}
              style={{ marginTop: 8 }}
            >
              {loading ? (
                <>
                  <div className="spinner" style={{ width: 18, height: 18, borderWidth: 2 }} />
                  جاري تسجيل الدخول...
                </>
              ) : 'دخول'}
            </button>
          </form>
        </div>

        <p style={styles.footer}>
          نظام إدارة العمولات © {new Date().getFullYear()} شركة ريادة طرية للدواجن
          <br />
          <span style={{ fontSize: 10, opacity: 0.7 }}>
            Developed by Mohamed Fawaz · All Rights Reserved
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    minHeight: '100dvh',
    background: 'linear-gradient(135deg, #052e16 0%, #065f46 50%, #047857 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    position: 'relative',
    overflow: 'hidden',
  },
  bg: {
    position: 'absolute',
    inset: 0,
    backgroundImage: `radial-gradient(circle at 20% 80%, rgba(34,197,94,0.15) 0%, transparent 50%),
                      radial-gradient(circle at 80% 20%, rgba(16,185,129,0.1) 0%, transparent 50%)`,
    pointerEvents: 'none',
  },
  container: {
    width: '100%',
    maxWidth: 400,
    position: 'relative',
    zIndex: 1,
  },
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    marginBottom: 32,
    justifyContent: 'center',
  },
  logoIcon: {
    width: 56,
    height: 56,
    background: 'rgba(255,255,255,0.15)',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  logoTitle: {
    fontSize: 22,
    fontWeight: 800,
    color: 'white',
    lineHeight: 1.2,
  },
  logoSub: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.7)',
    fontWeight: 400,
  },
  card: {
    background: 'white',
    borderRadius: 20,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  cardTitle: {
    fontSize: 22,
    fontWeight: 800,
    color: '#111827',
    marginBottom: 6,
  },
  cardSub: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 24,
  },
  footer: {
    textAlign: 'center',
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    marginTop: 24,
  },
};
